// extracted by mini-css-extract-plugin
export default {"container":"my-john-lewis-details_container__a9fc2","link":"my-john-lewis-details_link__b8a63"};